import { gsap } from 'gsap'
import { screenSizeCoefficient } from './utils/breakpoints'

let $html = $('html')
let screenWidth = $(window).width()
let screenHeight = $(window).height()
let defaultFontSize = 16
let smallScreenHeightFontSize = 16
let maxFontSize = 18
let fontSize = Math.floor(defaultFontSize * screenSizeCoefficient())

fontSize = fontSize > maxFontSize ? maxFontSize : fontSize

if (screenWidth > 1000 && screenHeight < 700) {
  $html.css('font-size', smallScreenHeightFontSize + 'px')
} else {
  $html.css('font-size', fontSize + 'px')
}

gsap.config({
  force3D: false,
  nullTargetWarn: false,
})

gsap.ticker.fps(-1)

$("#no-ie-support").remove()

$(window).on('load', function (){
  setTimeout(function (){
    $('.js-loading').css('opacity', 1)
  }, 450)

})

function pxToRem(value)
{
 return (fontSize / defaultFontSize) * value
}

export { pxToRem }
